import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { DeleteConfirmation } from '../types';
import Modal from './ui/Modal';

interface ConfirmDialogProps {
  confirmation: DeleteConfirmation;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ confirmation }) => {
  return (
    <Modal
      open={confirmation.isOpen}
      onClose={confirmation.onCancel}
      title={confirmation.title}
      icon={<AlertTriangle className="h-5 w-5 text-red-500" />}
      headerAccent="bg-red-50/50"
      maxWidth="md"
      footer={
        <>
          <button
            onClick={confirmation.onCancel}
            className="px-4 py-2 text-sm font-semibold text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-500/20 transition-all"
          >
            Cancel
          </button>
          <button
            onClick={confirmation.onConfirm}
            className="px-4 py-2 text-sm font-semibold text-white bg-red-600 border border-transparent rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500/20 shadow-sm hover:shadow transition-all"
          >
            Delete
          </button>
        </>
      }
    >
      <p className="text-slate-600 leading-relaxed">{confirmation.message}</p>
    </Modal>
  );
};

export default ConfirmDialog;
